// ---- Equipment / gear data (bought from the wave shop; logic lives lower down) ----
export const GEAR_TIERS = {   // shop has better legendary odds than world shrines
  common:    { color: '#d6def0', mul: 1.0,  price: 25,  weight: 0.50 },
  uncommon:  { color: '#5fdc7a', mul: 1.7,  price: 55,  weight: 0.32 },
  legendary: { color: '#ff6b5d', mul: 2.6,  price: 120, weight: 0.14 },
  lunar:     { color: '#7fb6ff', mul: 2.3,  price: 95,  weight: 0.04 },
};
export const GEAR_AFFIXES = [
  { key: 'damage',    base: [4, 9],     fmt: v => `+${v} damage` },
  { key: 'maxHp',     base: [14, 28],   fmt: v => `+${v} max HP` },
  { key: 'damage',    base: [3, 7],     fmt: v => `+${v} damage` },
  { key: 'maxSpeed',  base: [2, 5],     fmt: v => `+${v} move speed` },
  { key: 'magnet',    base: [12, 28],   fmt: v => `+${v} magnet` },
  { key: 'greed',     base: [8, 20],    fmt: v => `+${v}% coin value` },
  { key: 'fireRate',  base: [8, 18],    fmt: v => `+${v}% fire rate` },
  { key: 'armor',     base: [4, 9],     fmt: v => `+${v}% armor` },
  { key: 'regen',     base: [1, 3],     fmt: v => `+${v} regen` },
  { key: 'range',     base: [40, 90],   fmt: v => `+${v} bullet range` },
  { key: 'crit',      base: [4, 10],    fmt: v => `+${v}% crit chance` },
  { key: 'critdmg',   base: [12, 26],   fmt: v => `+${v}% crit damage` },   // trimmed in 0.14 — a legendary roll was +91% from one line
];
export const GEAR_NOUNS = ['Module', 'Core', 'Rig', 'Array', 'Cell', 'Matrix', 'Unit', 'Drive'];
export const GEAR_ICONS = ['⚙️', '🔧', '🛰️', '🔩', '📦', '💠', '🎛️'];
export const LEGENDARY_UNIQUES = [
  { key: 'homing',    name: 'Homing Rounds', icon: '🎯', desc: 'your shots curve into enemies' },
  { key: 'lifesteal', name: 'Leech Array',   icon: '🧛', desc: 'heal on every hit' },
  { key: 'detonator', name: 'Detonator',     icon: '💣', desc: 'enemy kills explode (full power with 2+ blast items)' },
  { key: 'timewarp',  name: 'Chrono Field',  icon: '⏳', desc: 'enemies move slower' },
  { key: 'railgun',   name: 'Railgun',       icon: '🛰️', desc: 'pierce all · huge dmg · slow fire' },
  { key: 'bulwark',   name: 'Bulwark',       icon: '🛡️', desc: '+armor & thorns, but slower' },
  { key: 'berserk',   name: 'Berserker',     icon: '😤', desc: 'more power the lower your HP' },
  { key: 'vortex',    name: 'Vortex',        icon: '🕳️', desc: 'pulls enemies toward you' },
  { key: 'ricochet',  name: 'Ricochet Rig',  icon: '🪃', desc: 'shots bounce to nearby enemies' },
  { key: 'boomerang', name: 'Boomerang Mod', icon: '↩️', desc: 'shots return — hitting twice' },
  { key: 'siphon',    name: 'Siphon Core',   icon: '🩸', desc: 'collecting coins heals you' },
  { key: 'momentum',  name: 'Kinetic Driver', icon: '🏎️', desc: 'more damage the faster you move' },
];
export const LUNAR_UNIQUES = [
  { key: 'splitshot', name: 'Fork Module',   icon: '🔀', desc: 'shots fork on hit — but +enemies' },
  { key: 'overdrive', name: 'Overdrive Core', icon: '🔥', desc: '+fire & damage — but +damage taken' },
];
